// WorkAbroadIntro.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const WorkAbroadIntro = () => {
  const considerations = [
    'Meeting role specific requirements and experience levels',
    'Passing eligibility and documentation checks',
    'Preparing for professional interviews',
    'Understanding employment terms and timelines',
    'Being ready for relocation and onboarding processes'
  ];

  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Left Column - Heading and Intro */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-6">
              What Working Abroad Really Involves
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              International employment is more than finding a vacancy. It requires meeting employer standards, demonstrating relevant experience, and preparing for formal recruitment processes.
            </p>
          </motion.div>

          {/* Right Column - Considerations List */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="text-gray-700 text-base font-normal mb-6">
              A successful work abroad journey typically involves:
            </p>
            
            <ul className="space-y-3">
              {considerations.map((item, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <CheckCircle size={18} className="text-gray-600 flex-shrink-0" />
                  <span className="text-gray-600 text-sm font-light">{item}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WorkAbroadIntro;
